import { render, staticRenderFns } from "./AdministrativePermitsSearchTable.vue?vue&type=template&id=1c89a66d&scoped=true"
import script from "./AdministrativePermitsSearchTable.vue?vue&type=script&lang=js"
export * from "./AdministrativePermitsSearchTable.vue?vue&type=script&lang=js"
import style0 from "./AdministrativePermitsSearchTable.vue?vue&type=style&index=0&id=1c89a66d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c89a66d",
  null
  
)

export default component.exports